import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

import { useSelectionInfoContext } from '../contexts/SelectionInfoContext';

export const useIsProductFamilyAiGenerationEnabled = () => {
  const { user } = useUser();
  const { vlmeConfig } = useSelectionInfoContext();

  const { data: featureFlags } = useFeatureFlags(['enable_product_family_ai_generation'], {
    user_id: user?.id || '',
    venue_country: vlmeConfig?.venue.country || '',
  });

  return featureFlags?.enable_product_family_ai_generation === 'on';
};
